import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ variant = "default" }) {
  const { i18n } = useTranslation();
  const cur = i18n.language?.startsWith("vi") ? "vi" : "en";
  const change = (lng) => i18n.changeLanguage(lng);
  const buttonCls = variant === "dark"
    ? "px-2.5 py-1.5 rounded-md text-xs font-semibold text-white/80 hover:text-primary hover:bg-white/5 flex items-center gap-1.5"
    : "px-2.5 py-1.5 rounded-md text-xs font-semibold text-secondary hover:text-primary hover:bg-muted flex items-center gap-1.5";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="lang-switcher" className={buttonCls} aria-label="Change language">
          <Globe className="w-4 h-4" />
          <span className="uppercase">{cur}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem data-testid="lang-en" onClick={() => change("en")} className={cur === "en" ? "font-semibold text-primary" : ""}>
          🇬🇧 English
        </DropdownMenuItem>
        <DropdownMenuItem data-testid="lang-vi" onClick={() => change("vi")} className={cur === "vi" ? "font-semibold text-primary" : ""}>
          🇻🇳 Tiếng Việt
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
